import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import InputMask from 'react-input-mask';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import $ from 'jquery'
import {
    Link, withRouter
} from 'react-router-dom';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import '../../stylesheet/virtualkeyboard.css'
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import Loader from '../loader/loader.jsx'
import LoaderSmall from "../loader/loadersmall.jsx"

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        }
    })

const JSEncrypt = window.JSEncrypt
class ManagePin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPIN: "",
            value: '',
            newPIN: "",
            loader: true,
            correctpin: true,
            confirmPIN: "",
            cardDetailsId: "",
            disabled: true,
            selectedCard: [],
            pinValue: "",
            customMapping: [

            ],
        }
        this.handleValueChange = this.handleValueChange.bind(this);
    }
    componentDidMount() {
        // $("KeyboardedInput").keydown(false);
        document.getElementById('oldpin').onkeypress = function () { return false; }
        document.getElementById('newpin').onkeypress = function () { return false; }
        document.getElementById('confpin').onkeypress = function () { return false; }
        // document.getElementById("numberpad").style.display = "none"
        const { publicKey } = this.props
       
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);


    }
    onChange = (e, value) => this.setState({
        [e.target.name]: e.target.value
    }, () => {
   
    })
    handleChange = (e) => {
      
        this.setState({
            [e.target.name]: e.target.value
        }, () => {

        })
    }

    handleChangePin = () => {
        const { publicKey } = this.props
        const { oldPIN, newPIN, confirmPIN } = this.state
       
        let _this = this;
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                cardDetailsId: encrypt.encrypt(this.state.cardDetailsId),
                oldPIN: encrypt.encrypt(this.state.oldPIN),
                newPIN: encrypt.encrypt(this.state.newPIN),
                applicationId: "gmcabs",
            }
           
            if (oldPIN.length == 4) {
                if (newPIN.length == 4) {
                    if (confirmPIN.length == 4) {
                        let token = "Token " + localStorage.getItem('token')

                        if (newPIN === confirmPIN) {
                            if(oldPIN !== newPIN){
                            fetch(s.change_pin + "/?Authorization=" + token, {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json',
                                }),
                                body: JSON.stringify(state)
                            })
                                .then(response => {
                                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                                        toast.success(response.headers.get('message'), {
                                            position: "top-right",
                                            draggablePercent: 60,
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: false
                                        });
                                        setTimeout(function () { window.location.reload(true); }, 1000);

                                    } else {
                                        toast.error(response.headers.get('message'), {
                                            position: "top-right",
                                            draggablePercent: 60,
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: false
                                        });



                                    }
                                })
                            } else {
                                toast.error('Old PIN should not be same as New Pin'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                };
                                setTimeout(function () {
                                    window.location.reload(1);
                                }, 3000);
                            }
                        
                        } else {
                            toast.error('New Pin and Confirm PIN should be same'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };
                            setTimeout(function () {
                                window.location.reload(1);
                            }, 3000);
                        }
                    } else {
                        toast.error('Confirm PIN should be 4 digits'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        };

                    }
                } else {
                    toast.error('New PIN should be 4 digits .'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            } else {
                toast.error('Old PIN should be 4 digits .'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };

            }
        }
    }
    componentWillReceiveProps(nextProps) {
     
        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                    selectedCard: nextProps.cardState.body[0]
                })
            }
        } catch (e) {

        }

    }
    handleValueChange(val) {
        if (val.length <= 4) {
            this.setState({ confirmPIN: val }
                , () => {

                    if (this.state.oldPIN !== "" && this.state.newPIN !== "" && this.state.confirmPIN !== "" ) {
                        this.setState({
                            disabled: false

                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }

                });
        }

      

    }
    removepin = () => {
        this.setState({
            correctpin: true
        })
    }
    handleValueChangeold(val) {
        if (val.length <= 4) {
            this.setState({ oldPIN: val }
                , () => {

                    if (this.state.oldPIN !== "" && this.state.newPIN !== "" && this.state.confirmPIN !== "" ) {
                        this.setState({
                            disabled: false

                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }

                });
        }

    }
    handleValueChangenew(val) {

        if (val.length <= 4) {
            this.setState({
                newPIN: val,
                correctpin: true,
            }
                , () => {

                    if (this.state.oldPIN !== "" && this.state.newPIN !== "" && this.state.confirmPIN !== "" ) {
                        this.setState({
                            disabled: false

                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }

                });
        }



       

    }
    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
                  
                    this.setState({

                        selectedCard: cardState.body[i]
                    })
                }
            }
        });

    }
    // When the user clicks on the password field, show the message box
    handleClick() {
        document.getElementById("numberpad").style.display = "block"
    }
    validatepin = (e) => {

    }
    render() {

        const { cardState } = this.props
        const { cardDetailsId, selectedCard, pinValue, loader, correctpin } = this.state
        return (
            
            <div style={{ padding: "0px 30px" }}>
                
                <div className="col-md-12 top-header text-left" style={{ marginBottom: "10px" }}>
                    {/* <h2>Change PIN</h2> */}
                    <span>Changing your card PIN is easy. Fields marked with an * must be filled. If you do not know your current PIN, you will need to Contact Us from the website and request a PIN reset. We will reset your PIN to the last 4 digits of your mobile phone number as per your profile. </span>
                </div>

                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?

                    <div className="card-account">

                        <div className="row">
                            <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                <div className="summary-header">
                                    <div className="row">
                                        <div className="col-md-6" style={{ marginTop: "6px" }}>
                                            <span style={{ fontSize: "17px", fontWeight: "600" }}>
                                                {selectedCard.cardProgramId}
                                            </span>
                                        </div>

                                        <div className="offset-md-1 col-md-5 text-right">
                                            <div className="row">
                                                <div className="col-sm-2 input-icon" >
                                                    {/* <img src={creditcardlogo} alt="" /> */}
                                                </div>
                                                <div className="col-sm-10" >
                                                    <SelectField
                                                        floatingLabelText=""
                                                        onChange={this.handleSelect1}
                                                        className="input-width"
                                                        name="Selected Card"
                                                        style={{ marginTop: -12 }}
                                                        value={cardDetailsId}>
                                                        {cardState.body.map((value, i) =>
                                                            <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                        )}
                                                    </SelectField>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tile box-shadow-style">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Card Number</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.cardNumber} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Name on Card</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.firstName + " " + selectedCard.lastName}  </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Last Credit Posted</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.lastCreditPosted}   </span><br />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Card Status</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.cardStatus}  </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Available Balance</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.availableBalance}</span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6  tilepadding">
                                            <label className="tilecontent">Ledger Balance</label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">{selectedCard.ledgerBalance}</span><br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <Loader />

                }
                <div className="change-pin">

                    <div className="tile box-shadow-style">
                        <div className="row">
                            <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                <div className="summary-header">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p>Change PIN Details</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 top-header text-left">
                                    <span>To help protect your security, the keyboard entry has been disabled. Please use the on-screen keypad to enter your card PIN. Click on the respective field to launch the on-screen keypad.</span>
                                </div>



                            </div>
                            <div className="col-md-12 col-sm-12" style={{ marginTop: '20px' }}>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row">
                                            <div className=" offset-md-1 col-md-11 col-sm-12">
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 passwordinput" >
                                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10 " >
                                                        <div className="group" id="oldpin">
                                                            <KeyboardedInput

                                                                type={"password"}
                                                                value={this.state.oldPIN}
                                                                onChange={(value) => { this.handleValueChangeold(value); }}
                                                                enabled
                                                                name={"oldPIN"}
                                                                opacity={1}
                                                                className="required"
                                                                defaultKeyboard={this.state.customMapping}
                                                                placeholder={'Enter 4 Digit Old Pin'}
                                                                step={4}
                                                                isDraggable={false}
                                                            />
                                                            <div id="errorold">Should contain maximum 4 digits</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-12 col-sm-12">
                                                <div className="row">
                                                    <div className="offset-md-1  col-md-11 col-sm-12">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-2 passwordinput" >
                                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                            </div>
                                                            <div className="col-sm-10" >
                                                                <div className="group" id="newpin" >
                                                                    <KeyboardedInput

                                                                        type={"password"}
                                                                        value={this.state.newPIN}
                                                                        onChange={(value) => { this.handleValueChangenew(value); }}
                                                                        enabled
                                                                        name={"newPIN"}
                                                                        opacity={1}
                                                                        className="required"
                                                                        defaultKeyboard={this.state.customMapping}
                                                                        placeholder={'Enter New 4 Digit Pin'}
                                                                        step={4}
                                                                        isDraggable={false}
                                                                        onBlur={this.removepin}
                                                                        errorText={correctpin ? null : "Should contain 4 digits."}

                                                                    />
                                                                    <div id="errornew">Should contain maximum 4 digits.</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-12 col-sm-12">
                                                <div className="row">
                                                    <div className="offset-md-1 col-md-11 col-sm-12" style={{ zIndex: "0" }}>
                                                        <div className="row input-group" >
                                                            <div className="col-sm-2 passwordinput" >
                                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                            </div>
                                                            <div className="col-sm-10" >
                                                                <div className="group" id="confpin" >
                                                                    <KeyboardedInput

                                                                        type={"password"}
                                                                        value={this.state.confirmPIN}
                                                                        onChange={(value) => { this.handleValueChange(value); }}
                                                                        enabled
                                                                        name={"confirmPIN"}
                                                                        opacity={1}
                                                                        className="required"
                                                                        defaultKeyboard={this.state.customMapping}
                                                                        placeholder={'Confirm Your Pin'}
                                                                        step={4}
                                                                        isDraggable={false}
                                                                    />
                                                                    {/* <InputMask type="password"
                                                                            name="confirmPIN"
                                                                            placeholder="Confirm Your Pin"
                                                                            onChange={this.onChange}
                                                                            maskChar="" /> */}
                                                                    <div id="errorconfirm">Should contain maximum 4 digits.</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                {/* <div className="row">
                                                        <div className="offset-md-1  col-md-11 col-sm-12">
                                                            <div className="row input-group" >
                                                                <KeyboardedInput
                                                                    enabled
                                                                    type={this.props.type}
                                                                    value={this.props.value}
                                                                    name={this.props.name}
                                                                    defaultKeyboard={CustomMapping}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> */}

                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-md-6">
                                            <a href="#b1" id="b1-link" className="link" rel="b1">Enable virtual keyboard</a>
                                            <div className='box' id='b1' style={{ position: "absolute", zIndex: "0" }}>
                                                <div type="text" id="numscreen" onFocus={this.handleClick.bind(this)}>
                                                </div>
                                                <div id="numberpad" className="numrow">
                                                    <div className="numrow">
                                                        <div id="num-1" className="num">1</div>
                                                        <div id="num-2" className="num">2</div>
                                                        <div id="num-3" className="num">3</div>
                                                    </div>
                                                    <div className="numrow">
                                                        <div id="num-4" className="num">4</div>
                                                        <div id="num-5" className="num">5</div>
                                                        <div id="num-6" className="num">6</div>
                                                    </div>
                                                    <div className="numrow">
                                                        <div id="num-7" className="num">7</div>
                                                        <div id="num-8" className="num">8</div>
                                                        <div id="num-9" className="num">9</div>
                                                    </div>
                                                    <div className="numrow">
                                                        <div id="num-d" className="num">DEL</div>
                                                        <div id="num-0" className="num">0</div>
                                                        <div id="num-c" className="num">CLR</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                </div>
                            </div>
                            <div className="offset-sm-3 col-sm-3">
                                <RaisedButton
                                    label="Change"
                                    disabled={this.state.disabled}
                                    className="pull-right"
                                    // style={styles.button}
                                    backgroundColor="#333"
                                    labelColor="#fff"
                                    onClick={this.handleChangePin}
                                    style={{ marginTop: "10px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div >

            </div >
        );
    }
}
ManagePin.defaultProps = {
    cardState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagePin);


// WEBPACK FOOTER //
// ./src/components/myprofile/managepin.jsx